// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "bar-xinglet-843b477e/chunk-" + {"410": "3c048cc1c7216cdd","559": "4e2c25b933ee93ad","937": "6192046f70b65703",}[chunkId] + ".js"
}